import { Pencil1Icon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrel } from 'features/kestrelViewer'
import React, { FC } from 'react'
import styled from 'styled-components'

const StyledPencilIcon = styled(Pencil1Icon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const GenericEditButton: FC<{
  itemId: string
  tooltipLabel: string
  onEdit: (e: React.MouseEvent) => void
}> = ({ itemId, tooltipLabel, onEdit }) => {
  const { selectedMarkup, setSelectedMarkup } = useKestrel()

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()

    // Check if popup is open for this item
    const isCurrentlySelected = selectedMarkup?.id === itemId

    if (isCurrentlySelected) {
      // If already selected, close the popup
      setSelectedMarkup(undefined)
    } else {
      // If not selected, open the popup
      onEdit(e)
    }
  }

  return (
    <TooltipWrapper side={'top'} label={tooltipLabel}>
      <div
        style={{ cursor: 'pointer', marginLeft: '-4px' }}
        onClick={handleClick}
        data-action-button='true'>
        <StyledPencilIcon width={20} height={20} />
      </div>
    </TooltipWrapper>
  )
}
